// Receive user input, output actions

import FilterBus from "./fw/filterbus";

export default function () { return new FilterBus({
        "touchstart" : function (touchevent) {
            if (touchevent.touches.length > 0) {
                return {
                    channel : "control",
                    message : { 
                        action: "activate",
                        x: touchevent.touches.item(0).pageX,
                        y: touchevent.touches.item(0).pageY
                    }
                };
            }
        },

        "touchend" : function (touchevent) {},
        "click" : function (mouseevent) {
            return {
                channel : "control",
                message : {
                    action: "activate",
                    x: mouseevent.pageX,
                    y: mouseevent.pageY
                }
            };
        },

        "mousemove" : function (mouseevent) {},
        "keydown" : function (keyevent) {
            if (keyevent.key == "a") {
                return {
                    channel : "rotate",
                    message : "anticlockwise"
                };
            } else if (keyevent.key == "d") {
                return {
                    channel : "rotate",
                    message : "clockwise"
                };
            }
        },

        "keyup" : function (keyevent) {
            if (keyevent.key == "a" || keyevent.key == "d") {
                return {
                    channel : "rotate",
                    message : "stop"
                };
            }
        }
    });
}
